import { useSyncExternalStore } from 'react';

function getSnapshot() {
  return navigator.onLine;
}

function getServerSnapshot() {
  return true;
}

function subscribe(callback: () => void) {
  const controller = new AbortController();
  window.addEventListener('online', callback, { signal: controller.signal });
  window.addEventListener('offline', callback, { signal: controller.signal });
  return () => controller.abort();
}

export function useOnline() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
